import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuItem, Tooltip } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import logoWhite from "assets/dsv-log-wh.png";
import logoTEA from "assets/logo-tea-nav.png";
import { Link } from "react-router-dom";
import Icons from "shared/icons";
import "style/pages.css";
import "./Navbar.styles.css";
// TODO decomposition according to fsd
import { userStore } from "entities/User/store/userStore";
import CompanySwitchDropdown from "modules/CompanySwitch/components/CompanySwitch.Dropdown/CompanySwitch.Dropdown";
import CountrySwitchDropdown from "modules/CountrySwitch/components/CountrySwitch.Dropdown/CountrySwitch.Dropdown";
import { Suspense, lazy, useState } from "react";
import { useTranslation } from "react-i18next";
import Drawer from "./Drawer/Drawer";
import ScrollableNavbarItems from "./ScrollableNavbarItems/ScrollableNavbarItems";
import { authService } from "features/Auth";

const TesterPanel = lazy(() => import("widgets/TesterPanel"));

function Navbar() {
  const isUserTester = userStore((state) => state.isUserTester);
  const { t } = useTranslation("Shared");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    event.stopPropagation();
    setAnchorElUser(event.currentTarget);
  };

  const [testerDrawerOpen, setTesterDrawerOpen] = useState(false);

  const handleTesterDrawerToggle = () => {
    setTesterDrawerOpen((prevState) => !prevState);
  };

  const handleLogout = () => {
    setIsLoggingOut(true);
    authService.logout().finally(() => {
      setIsLoggingOut(false);
    });
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const isProductionEnvironment = location.hostname === "tea.dsv.com";

  return (
    <Box sx={{ pb: isProductionEnvironment ? 8 : 12 }}>
      <AppBar component="nav" sx={{ backgroundColor: "#002664" }}>
        {!isProductionEnvironment && (
          <div className="stripes">TEST ENVIRONMENT</div>
        )}
        <Toolbar>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: { sm: 0, xs: 1 },
              flexBasis: 0,
            }}
          >
            <Link to="/" target="_self">
              <img src={logoWhite} width="100" height="auto" alt="DSV" />
            </Link>
          </Typography>
          <Box
            sx={{
              flexBasis: 0,
              flexGrow: 1,
              textAlign: "end",
              display: { md: "none" },
            }}
          >
            <IconButton
              size="large"
              color="inherit"
              aria-label="menu"
              onClick={handleDrawerToggle}
              sx={{
                color: "white",
                fontSize: "1.2rem",
              }}
            >
              <FontAwesomeIcon icon={Icons.bars} />
            </IconButton>
          </Box>
          <ScrollableNavbarItems />
          <Box
            sx={{
              gap: 1.5,
              display: { xs: "none", md: "flex" },
              whiteSpace: "nowrap",
            }}
          >
            <CompanySwitchDropdown />
            <CountrySwitchDropdown />
            <Typography
              variant="h6"
              to="/"
              target="_self"
              component={Link}
              sx={{
                mx: 2,
                color: "white",
                "&:hover": {
                  color: "white",
                },
                fontSize: "0.9rem",
                display: { lg: "flex", md: "none", sm: "none" },
                alignItems: "center",
              }}
            >
              <img
                src={logoTEA}
                width="45px"
                height="auto"
                alt="TEA"
                className="me-2"
              />
              {t("application_name")}
            </Typography>
            {isUserTester && (
              <Tooltip title={t("tester_panel")}>
                <IconButton
                  size="large"
                  color="inherit"
                  aria-label="options"
                  onClick={handleTesterDrawerToggle}
                  sx={{ color: "white", fontSize: "1rem" }}
                >
                  <Icons.bugReport sx={{ color: "gold" }} />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={t("profile")}>
              <IconButton
                size="large"
                color="inherit"
                aria-label="options"
                onClick={handleOpenUserMenu}
                sx={{ color: "white", fontSize: "1rem" }}
              >
                <FontAwesomeIcon icon={Icons.user} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              disableScrollLock
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              <MenuItem
                component={Link}
                to="/profile"
                onClick={handleCloseUserMenu}
                sx={{
                  "&:hover": {
                    color: "black",
                  },
                }}
              >
                <Typography>
                  <FontAwesomeIcon icon={Icons.user} className="me-3" />
                  {t("profile")}
                </Typography>
              </MenuItem>
              <MenuItem disabled={isLoggingOut} onClick={handleLogout}>
                <Typography>
                  <FontAwesomeIcon
                    icon={Icons.arrowRightFromBracket}
                    className="me-3"
                  />
                  {isLoggingOut ? t("loading") : t("logout")}
                </Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          handleLogout={handleLogout}
          handleDrawerToggle={handleDrawerToggle}
          handleTesterDrawerToggle={handleTesterDrawerToggle}
          mobileOpen={mobileOpen}
        />
        <Suspense>
          {isUserTester ? (
            <TesterPanel
              testerDrawerOpen={testerDrawerOpen}
              handleTesterDrawerToggle={handleTesterDrawerToggle}
            />
          ) : null}
        </Suspense>
      </Box>
    </Box>
  );
}

export default Navbar;
